import React from 'react';
import { Checkbox } from 'antd';
import Text from 'components/Text/Text';

interface IProps {
	toggleUseCustomerStopListSyncInterval: () => void;
	useCustomerStopListSyncInterval: boolean;
}

export const UseCustomerStopListSyncIntervalCheckBox: React.FC<IProps> = React.memo(
	({ toggleUseCustomerStopListSyncInterval, useCustomerStopListSyncInterval }) => {
		return (
			<div className="mb-2">
				<Checkbox
					data-test="UseCustomerStopListSyncIntervalCheckBox"
					onChange={toggleUseCustomerStopListSyncInterval}
					checked={useCustomerStopListSyncInterval}>
					<Text translationNameSpace="form" translationKey="useCustomerSettingsLabel" asFragment={true} />
				</Checkbox>
			</div>
		);
	},
);
